import React from "react";
import styled from "styled-components";
import arrow from "../../styles/images/ico_arrow_down.svg";

const CompanyInfo = (props) => {
  return (
    <CompanyInfoWrap>
      <details>
        <summary>
          <TitleDiv>
            <h4>모빌리전트(주) 사업자 정보</h4>
            <img src={arrow} alt="arrow" className="pointer" />
          </TitleDiv>
        </summary>
        <ul>
          <li>주식회사 : 모빌리전트</li>
          <li>주소 : 경북 포항시 남구 청암로 87, 5층 536호</li>
          <li>사업자등록번호 : 588-86-01463</li>
        </ul>

        <div>
          <span>@MOBILIGENT Co. Ltd. ALL RIGHTS RESERVED</span>
        </div>
        <div>
          <p>Powered by AMOBlock</p>
        </div>
      </details>
    </CompanyInfoWrap>
  );
};

export default CompanyInfo;

const CompanyInfoWrap = styled.div`
  padding: 4rem 2rem;
  background-color: ${({ theme }) => theme.color.purple_bg_dark};
  ul {
    margin-top: 2rem;
  }
  li {
    font-size: 1.5rem;
    line-height: 2rem; /* 100% */
    color: ${({ theme }) => theme.color.input_text_gray_dark};
  }
  div {
    margin-top: 1.5rem;
  }
  span,
  p {
    font-size: 1.2rem;
    line-height: 1.6rem;
    color: ${({ theme }) => theme.color.input_text_gray};
  }
  details[open] {
    summary {
      img {
        transform: rotate(180deg);
      }
    }
  }
`;
const TitleDiv = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1rem;
  h4 {
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 1.8rem; /* 100% */
  }
  img {
    margin-left: 1rem;
  }
`;
